export function beforeSave(record) {
  const newRecord = { ...record };

  if (!record.smsEnabled) {
    newRecord.mobileNumber = null;
  }

  newRecord.timeZone = record.timeZone?.id || null;
  newRecord.dateFormat = record.dateFormat?.id || null;
  newRecord.notificationMethod = record.notificationMethod?.id || null;
  newRecord.passwordQuestion = record.passwordQuestion?.id || null;
  newRecord.mobileCarrier = record.mobileCarrier?.id || null;

  delete newRecord.smsEnabled;
  delete newRecord.confirmEmail;

  return newRecord;
}
